import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.mobileMenu = null;
    this.orientation = this.getOrientation();
    this.lastScrollPosition = 0;
    this.mobileMaxWidth = 769;

    // Set up resize observer for orientation changes and viewport changes
    this.resizeObserver = new ResizeObserver(() => {
      this.handleResize();
    });
    this.resizeObserver.observe(document.body);
  }

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  toggle() {
    if (!this.mobileMenu) {
      // Clone footer navigation to create mobile menu
      const footerContainer = document.querySelector("footer > div > #container");
      if (footerContainer) {
        this.mobileMenu = footerContainer.cloneNode(true);
        this.mobileMenu.id = "mobileMenu";
        document.body.appendChild(this.mobileMenu);
      }
    }

    if (this.mobileMenu && this.mobileMenu.style.display === "block") {
      // Hide mobile menu
      this.reset();
    } else if (this.mobileMenu) {
      // Show mobile menu
      this.lastScrollPosition = window.scrollY;
      window.scrollTo(0, 0);
      document.querySelector("main").style.display = "none";
      document.querySelector("footer").style.display = "none";
      this.mobileMenu.style.display = "block";
    }
  }

  reset() {
    const main = document.querySelector("main");
    const footer = document.querySelector("footer");

    if (main) main.style.display = "";
    if (footer) footer.style.display = "";

    window.scrollTo(0, this.lastScrollPosition);

    if (this.mobileMenu) {
      this.mobileMenu.style.display = "none";
    }
  }

  getOrientation() {
    return window.innerWidth > window.innerHeight ? "landscape" : "portrait";
  }

  handleResize() {
    // Close menu when shifting from mobile to full layout
    if (window.innerWidth > this.mobileMaxWidth) {
      this.reset();
    }

    // Close menu on orientation change
    const newOrientation = this.getOrientation();
    if (this.orientation !== newOrientation) {
      this.orientation = newOrientation;
      this.reset();
    }
  }
}
